import { GeneratorSystemDesign } from 'types';

export const calculateGeneratorSystemDesignTotalCost = (systemDesign: GeneratorSystemDesign): number => {
  const totalCost = systemDesign?.systems?.reduce((sum, system) => {
    return (
      sum +
      // Site prep, accessories, and discounts are temporarily commented out for the generator program; may return.
      parseFloat((system.equipment.totalCost as any) || 0)
      // + parseFloat((system.sitePrep?.totalCost as any) || 0)
      // + parseFloat((system.accessories?.totalCost as any) || 0)
      // - parseFloat((system.discounts?.totalCost as any) || 0)
    );
  }, 0);
  return Math.round((totalCost || 0) * 100) / 100;
};
